import { type NextProfitsResponse, nextProfitsResponseSchema } from 'investments/common/definitions'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { type UseQueryRequestOptions, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

async function fetchBucketNextProfits({ accountId, bucketId }: { accountId: string; bucketId: string }) {
  const { data } = await httpClientBanking({
    url: `/investments/accounts/${accountId}/buckets/${bucketId}/next_profits`,
    method: 'GET'
  })

  return nextProfitsResponseSchema.parse(data)
}

export function getUseFetchBucketNextProfitsKey(accountId: string, bucketId: string) {
  return ['useFetchBucketNextProfits', accountId, bucketId] as const
}

export function useFetchBucketNextProfits({
  accountId,
  bucketId,
  options
}: {
  accountId: string
  bucketId: string
  options?: UseQueryRequestOptions<NextProfitsResponse, unknown, true>
}) {
  return useQueryRequest<NextProfitsResponse, unknown, true>(
    getUseFetchBucketNextProfitsKey(accountId, bucketId),
    () => fetchBucketNextProfits({ accountId, bucketId }),
    {
      suspense: false,
      retry: false,
      ...options
    }
  )
}
